import React, { Component } from "react";
import "./Login.css";
import axios from "axios";
import "./Register.css";
import { Link } from "react-router-dom";
import { withRouter } from "react-router-dom";

class Register extends Component {
  state = {
    credentials: {
      first_name: "",
      last_name: "",
      email: "",
      username: "",
      password: "",
      token: this.props.match.params.uid ? this.props.match.params.uid : "",
    },
    repeat_password: "",
    validationErrors: [],
    errors: [],
  };

  register = async () => {
    const cred = {};
    cred["first_name"] = "";
    cred["last_name"] = "";
    cred["email"] = "";
    cred["username"] = "";
    cred["password"] = "";
    cred["token"] = "";

    let validated = true;
    for (var [key, value] of Object.entries(this.state.credentials)) {
      if (value === "") {
        switch (key) {
          case "token":
            cred[key] = "Enter registration key";
            break;
          case "username":
            cred[key] = "Enter username";
            break;
          case "password":
            cred[key] = "Enter password";
            break;
          case "first_name":
            cred[key] = "Enter first name";
            break;
          case "last_name":
            cred[key] = "Enter last name";
            break;
          default:
            cred[key] = "Enter email";
        }

        await this.setState({ validationErrors: cred });
        validated = false;
      } else if (key === "email" && !this.validateEmail(value)) {
        cred[key] = "Enter a valid email address";
        await this.setState({ validationErrors: cred });
        validated = false;
      }
    }
    if (this.state.credentials.password !== this.state.repeat_password) {
      cred[key] = "Passwords do not match";
      await this.setState({ validationErrors: cred });
      validated = false;
    }

    if (!validated) {
      this.renderErrors();
      return;
    }

    let service = axios.create({
      baseURL: this.props.baseUrl + "/api",
      responseType: "json",
    });

    let val_pwd = {}
    val_pwd["password"] = this.state.repeat_password;;

    axios
      .post(
        this.props.baseUrl + "/api/register/",
        val_pwd
      )
      .then((response) => {
        service
          .post("/api/users/", this.state.credentials, {
            withCredentials: true,
          })
          .then((response) => {
            this.props.setRegistered(true);
            this.props.toggle();
          })
          .catch((errors) => {
            this.setState({ validationErrors: errors.response.data });
            this.renderErrors();
          });
      })
      .catch((errors) => {
        this.setState({ validationErrors: errors.response.data });
        this.renderErrors();
      });
    return;
  };

  inputChanged = (event) => {
    const cred = this.state.credentials;
    cred[event.target.name] = event.target.value;
    this.setState({ credentials: cred });
  };
  repeatPwdChanged = (event) => {
    this.setState({ repeat_password: event.target.value });
  };

  keyChanged = (event) => {
    this.setState({ key: event.target.value });
  };

  componentDidMount(){
    const cred = this.state.credentials;
    let search = window.location.search;
    let params = new URLSearchParams(search);
    let first = params.get('first');
    let last = params.get('last');
    let email = params.get('email');
    if(first){
      cred['first_name']= first
    }
    if(last){
      cred['last_name']= last
    }
    if(email){
      cred['email']= email
    }
    this.setState({ credentials: cred });
  }

  renderErrors = () => {
    const validationErrors = this.state.validationErrors;
    const error_tags = [
      "username",
      "password",
      "first_name",
      "last_name",
      "non_field_errors",
      "token",
      "email",
    ];
    let errors = [];

    var arrayLength = error_tags.length;
    for (var i = 0; i < arrayLength; i++) {
      const error_tag = error_tags[i];
      const error_msg = validationErrors[error_tag];
      if (error_msg) {
        errors.push(<li key={error_tags[i]}>{error_msg}</li>);
      }
    }

    this.setState({ errors: errors });
    return;
  };

  validateEmail = (mail) => {
    if (
      /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(
        mail
      )
    ) {
      return true;
    }
    return false;
  };

  render() {
    return (
      <div className="input_area">
        <div className="title_area">
          <h1>Register</h1>
        </div>
        {!this.props.match.params.uid ? (
          <div className="key_area">
            <label>
              Registration key:
              <br />
              <input
                type="text"
                name="token"
                value={this.state.credentials.token}
                onChange={this.inputChanged}
                maxLength="120"
              />
            </label>
            <div className="join_link">
              <Link to={this.props.baseUrl+"/join"}>Don't have a key?</Link>
            </div>
          </div>
        ) : (
          <></>
        )}

        <div className="name_area">
          <label>
            First Name:
            <br />
            <input
              type="text"
              name="first_name"
              value={this.state.credentials.first_name}
              onChange={this.inputChanged}
              maxLength="100"
            />
          </label>
          <label>
            Last Name:
            <br />
            <input
              type="text"
              name="last_name"
              value={this.state.credentials.last_name}
              onChange={this.inputChanged}
              maxLength="100"
            />
          </label>
        </div>
        <label>
          Email:
          <br />
          <input
            type="text"
            name="email"
            value={this.state.credentials.email}
            onChange={this.inputChanged}
            maxLength="320"
          />
        </label>
        <br />
        <label>
          Username:
          <br />
          <input
            type="text"
            name="username"
            value={this.state.credentials.username}
            onChange={this.inputChanged}
            maxLength="100"
          />
        </label>
        <br />
        <label>
          Password:
          <br />
          <input
            type="password"
            name="password"
            value={this.state.credentials.password}
            onChange={this.inputChanged}
            maxLength="1000"
          />
        </label>
        <label>
          Repeat Password:
          <br />
          <input
            type="password"
            name="repeat_password"
            value={this.state.repeat_password}
            onChange={this.repeatPwdChanged}
            maxLength="1000"
          />
        </label>
        <button
          className="login_button"
          onClick={() => {
            this.register();
          }}
        >
          Register
        </button>
        <ul style={{ color: "red", marginTop: "10px" }}>{this.state.errors}</ul>
        <div className="separator">Already have an Account?</div>
        <button className="register_button" onClick={this.props.toggle}>
          Sign In
        </button>
      </div>
    );
  }
}

export default withRouter(Register);
